import React, { useState } from 'react'
import { Pressable, Text, View } from 'react-native'
import Animated, { useAnimatedStyle, useSharedValue, withTiming } from 'react-native-reanimated'

import { IMAGE } from '@ui-kit/assets/images/index.native'
import Icon from '@ui-kit/components/Icon'
import { tableCategoryAccordion } from '@ui-kit/components/Table/TableCategoryAccordion/styles'
import TableCategoryAccordionContent from '@ui-kit/components/Table/TableCategoryAccordionContent/index.native'
import type { TableCategoryRow } from '@ui-kit/components/Table/types'

interface Props {
  categoryRow: TableCategoryRow
  isLast: boolean
}

const TableCategoryAccordion = (props: Props) => {
  const [isExpanded, setIsExpanded] = useState(props.categoryRow.isExpandedByDefault)
  const { row, title } = tableCategoryAccordion({ isLast: props.isLast })

  const rotate = useSharedValue('0deg')

  const iconStyle = useAnimatedStyle(() => {
    return {
      transform: [{ rotate: rotate.value }],
    }
  })

  React.useEffect(() => {
    rotate.value = withTiming(isExpanded ? '180deg' : '0deg', {
      duration: 300,
    })
  }, [isExpanded, rotate])

  return (
    <View>
      <Pressable className={row()} onPress={() => setIsExpanded(!isExpanded)}>
        <Text className={title()}>{props.categoryRow.title}</Text>
        <Animated.View style={iconStyle}>
          <Icon imgSrc={IMAGE.icons.xsmall.action.chevronDown_16} />
        </Animated.View>
      </Pressable>
      {isExpanded &&
        props.categoryRow.rows.map((r, rowIndex) => (
          <TableCategoryAccordionContent key={r.key} rowContent={r} isFirst={rowIndex === 0} />
        ))}
    </View>
  )
}

export default TableCategoryAccordion
